import React, { Component } from 'react';

import Footer from '../../components/Footer';
import Button from '../../components/Button';

import './style.css';

class NotFound extends Component {
  componentDidMount() {
    document.title = `Página não encontrada - Stroop`;
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div id="not-found">
        <header id="header">
          <div className="top-bar">
            <div className="container">
              <div className="logo">
                <div className="logo-text">Stroop App</div>
                <div className="logo-version">
                  {process.env.REACT_APP_VERSION}
                </div>
              </div>
            </div>
          </div>

          <div className="heightHeader"></div>
        </header>
        <div className="not-found-content">
          <div className="error-info">
            <div className="error-code">404</div>
            <div className="error-title">Página não encontrada</div>
            <div className="error-message">
              A página que você está procurando não existe ou foi removida.
            </div>
          </div>

          <div className="actions">
            <Button
              className="full primary"
              link={`${process.env.PUBLIC_URL}/`}
            >
              Voltar ao Login
            </Button>

            <Button
              className="full secondary"
              onClick={() => window.history.back()}
            >
              Voltar à página anterior
            </Button>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default NotFound;
